import {
  type FC, useEffect,
} from 'react';
import {
  type RouteProps, useLocation, useNavigate,
} from 'react-router-dom';
import { LogoVersion } from '~/_shared/components/logo/logo.helpers';
import { OverlayLoaderComponent } from '~/_shared/components/overlay/overlayLoader.component';
import { LoginPageContentWrapperComponent } from '~/authorization/loginPage/loginPageContentWrapper.component';
import { LoginFormContainer } from './loginForm/loginForm.container';

const LOGIN_PAGE_CANONICAL_URL = 'https://www.maptive.com/login.html';

type LoginPageProps = RouteProps & {
  isLoading?: boolean;
  isUserSignedIn: boolean;

  onLoginFormSubmit: () => void;
};

export const LoginPageComponent: FC<LoginPageProps> = (props) => {
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (props.isUserSignedIn) {
      navigate(state?.from ?? '/');
    }
  }, [navigate, props.isUserSignedIn, state?.from]);

  return (
    <>
      <link rel="canonical" href={LOGIN_PAGE_CANONICAL_URL} />
      <LoginPageContentWrapperComponent
        logoVersion={LogoVersion.variantB}
      >
        {props.isLoading && <OverlayLoaderComponent />}
        {!props.isLoading && (
          <LoginFormContainer onLoginFormSubmit={props.onLoginFormSubmit} />
        )}
      </LoginPageContentWrapperComponent>
    </>
  );
};
